import axiosInstance
  from '../../../config/axiosInstance';

import type {
  MarginCenterRevenueContractionIntelligenceResponse,
  MarginCenterSituationIntelligenceParams,
} from '../types/situationIntelligence';


const MARGIN_CENTER_BASE_PATH =
  '/pricing/margin-center';


export async function getMarginCenterRevenueContractionIntelligence(
  params: MarginCenterSituationIntelligenceParams = {},
): Promise<MarginCenterRevenueContractionIntelligenceResponse> {
  const { data } =
    await axiosInstance.get<MarginCenterRevenueContractionIntelligenceResponse>(
      `${MARGIN_CENTER_BASE_PATH}/situations/revenue-contraction/intelligence`,
      {
        params,
      },
    );

  return data;
}
